import React from 'react';

export default function AvisoPrivacidadContent() {
  return (
    <>
      <p className="legal-lead">
        En cumplimiento con lo dispuesto por la Ley Federal de Protección de Datos
        Personales en Posesión de los Particulares (LFPDPPP), su Reglamento y los
        Lineamientos del Aviso de Privacidad, el presente documento describe la forma
        y los términos en que <strong>Quru, S.A. de C.V.</strong> (en adelante,
        &quot;Quru&quot;), tratará los datos personales de los Titulares que tengan
        contacto con Santa Mónica Residencial a través de cualquiera de sus canales
        digitales y presenciales.
      </p>

      <h2>1. Identidad y domicilio del Responsable</h2>
      <p>
        <strong>Quru, S.A. de C.V.</strong>, con domicilio para oír y recibir
        notificaciones en la ciudad de Pachuca de Soto, estado de Hidalgo, código
        postal 42000, México (en adelante, el &quot;Responsable&quot;), es el
        responsable del tratamiento, uso, protección y resguardo de los datos
        personales que recabe, conforme al presente Aviso.
      </p>

      <h2>2. Datos personales que se recaban</h2>
      <p>
        El Responsable podrá recabar, de forma directa, indirecta o a través de
        terceros autorizados, las siguientes categorías de datos personales:
      </p>
      <ul>
        <li><strong>Datos de identificación:</strong> nombre completo, fecha de nacimiento, nacionalidad, identificación oficial, fotografía cuando aplique.</li>
        <li><strong>Datos de contacto:</strong> teléfono fijo, teléfono móvil, correo electrónico, dirección postal, redes sociales y otros medios de comunicación.</li>
        <li><strong>Datos patrimoniales y financieros:</strong> ingresos, fuentes de ingresos, historial crediticio, cuentas bancarias, créditos hipotecarios contratados o por contratar, y referencias personales y financieras, exclusivamente cuando el Titular manifieste interés en adquirir una vivienda mediante crédito.</li>
        <li><strong>Datos laborales:</strong> empleador, antigüedad, puesto, y comprobantes de ingresos, exclusivamente para procesos de precalificación.</li>
        <li><strong>Datos de navegación:</strong> dirección IP, identificador del dispositivo, sistema operativo, tipo de navegador, ubicación geográfica aproximada, páginas visitadas dentro del sitio y datos derivados de cookies (ver Sección 9).</li>
      </ul>
      <p>
        El Responsable no recaba datos personales sensibles, salvo aquéllos
        estrictamente necesarios para el cumplimiento de obligaciones legales o
        fiscales, en cuyo caso se solicitará el consentimiento expreso por escrito.
      </p>

      <h2>3. Finalidades del tratamiento</h2>
      <p><strong>Finalidades primarias</strong> (necesarias para la relación con el Titular):</p>
      <ul>
        <li>Atender solicitudes de información sobre el desarrollo Santa Mónica Residencial y sus modelos de vivienda.</li>
        <li>Coordinar y dar seguimiento a visitas a la sala de ventas y al desarrollo.</li>
        <li>Generar cotizaciones, propuestas comerciales y contratos de promesa de compra-venta.</li>
        <li>Realizar precalificaciones crediticias y dar seguimiento al proceso de obtención del crédito hipotecario.</li>
        <li>Gestionar la escrituración, entrega de vivienda y servicios postventa.</li>
        <li>Cumplir con obligaciones fiscales, contables, jurídicas, administrativas y de prevención de operaciones con recursos de procedencia ilícita.</li>
      </ul>
      <p><strong>Finalidades secundarias</strong> (opcionales y revocables):</p>
      <ul>
        <li>Envío de comunicaciones comerciales, promociones, novedades y eventos relacionados con Santa Mónica Residencial y otros desarrollos del Responsable.</li>
        <li>Estudios estadísticos y de mercado para mejorar nuestros productos y servicios.</li>
        <li>Encuestas de satisfacción y calidad del servicio.</li>
      </ul>
      <p>
        Si el Titular no desea que sus datos sean tratados para alguna de las
        finalidades secundarias, podrá manifestarlo en cualquier momento al correo{' '}
        <a href="mailto:contacto@quru.mx">contacto@quru.mx</a>, sin que ello afecte
        la relación con el Responsable ni la prestación del servicio principal.
      </p>

      <h2>4. Transferencias de datos personales</h2>
      <p>
        El Responsable podrá transferir los datos personales del Titular,
        exclusivamente para el cumplimiento de las finalidades descritas en este
        Aviso, a los siguientes terceros:
      </p>
      <ul>
        <li><strong>Instituciones bancarias y financieras</strong> (BBVA, Santander, Banorte, Scotiabank, HSBC y otras), así como a organismos públicos de vivienda (INFONAVIT, FOVISSSTE) para procesos de precalificación, otorgamiento y administración del crédito hipotecario.</li>
        <li><strong>Notarías públicas</strong> autorizadas para la formalización del contrato de compra-venta, escrituración y demás trámites notariales correspondientes.</li>
        <li><strong>Proveedores de servicios</strong> indispensables para la escrituración y entrega de la vivienda (avalúos, peritos, gestores, despachos jurídicos y contables).</li>
        <li><strong>Autoridades competentes</strong> en los casos legalmente exigidos.</li>
      </ul>
      <p>
        Estas transferencias son necesarias para el cumplimiento de la relación
        jurídica entre el Titular y el Responsable, por lo que no requieren del
        consentimiento expreso del Titular conforme al artículo 37 de la LFPDPPP.
      </p>

      <h2>5. Derechos ARCO y revocación del consentimiento</h2>
      <p>
        El Titular tiene derecho a conocer qué datos personales tenemos de él, para
        qué los utilizamos y las condiciones del uso que les damos (Acceso). Asimismo,
        tiene derecho a solicitar la corrección de su información personal en caso
        de que esté desactualizada, sea inexacta o incompleta (Rectificación); que
        eliminemos sus datos de nuestros registros cuando considere que no están
        siendo utilizados conforme a los principios, deberes y obligaciones previstas
        en la normativa (Cancelación); así como oponerse al uso de sus datos
        personales para fines específicos (Oposición). En conjunto, estos derechos
        se conocen como <strong>derechos ARCO</strong>.
      </p>
      <p>
        Para el ejercicio de los derechos ARCO o la revocación del consentimiento, el
        Titular deberá enviar una solicitud al correo electrónico{' '}
        <a href="mailto:contacto@quru.mx">contacto@quru.mx</a> con la siguiente
        información:
      </p>
      <ul>
        <li>Nombre completo y datos de contacto del Titular.</li>
        <li>Documentos que acrediten su identidad (o, en su caso, la personalidad de su representante legal).</li>
        <li>Descripción clara y precisa de los datos personales respecto de los cuales se pretende ejercer alguno de los derechos ARCO.</li>
        <li>Cualquier otro elemento que facilite la localización de los datos personales.</li>
      </ul>
      <p>
        El Responsable dará respuesta a la solicitud en un plazo no mayor a veinte
        (20) días hábiles contados a partir de su recepción, conforme al artículo 32
        de la LFPDPPP.
      </p>

      <h2>6. Medios para limitar el uso o divulgación de datos</h2>
      <p>
        El Titular puede limitar el uso o divulgación de sus datos personales
        enviando una solicitud al correo{' '}
        <a href="mailto:contacto@quru.mx">contacto@quru.mx</a>. Asimismo, podrá
        inscribirse al Registro Público para Evitar Publicidad (REPEP) de la
        Procuraduría Federal del Consumidor para no recibir publicidad de bienes y
        servicios.
      </p>

      <h2>7. Medidas de seguridad</h2>
      <p>
        El Responsable ha implementado y mantiene medidas de seguridad
        administrativas, técnicas y físicas para proteger los datos personales contra
        daño, pérdida, alteración, destrucción o uso, acceso o tratamiento no
        autorizado. Únicamente personal autorizado tiene acceso a la información, y
        toda transmisión digital se realiza mediante conexiones cifradas (HTTPS/TLS).
      </p>

      <h2>8. Conservación de los datos</h2>
      <p>
        Los datos personales del Titular se conservarán durante el tiempo necesario
        para cumplir con las finalidades descritas en este Aviso y, posteriormente,
        durante los plazos exigidos por la legislación fiscal, civil y mercantil
        aplicable (hasta un máximo de diez años, salvo disposición legal en
        contrario), después de los cuales serán bloqueados y eliminados.
      </p>

      <h2>9. Uso de cookies, web beacons y tecnologías similares</h2>
      <p>
        El sitio <strong>santamonicaresidencial.mx</strong> utiliza cookies y
        tecnologías similares con el fin de mejorar la experiencia de navegación,
        recordar preferencias del usuario, medir el desempeño del sitio y mostrar
        contenido relevante. Las cookies utilizadas son:
      </p>
      <ul>
        <li><strong>Cookies estrictamente necesarias:</strong> indispensables para el funcionamiento del sitio (gestión de sesión, seguridad). No requieren consentimiento.</li>
        <li><strong>Cookies de desempeño y analítica:</strong> permiten conocer el comportamiento agregado de los usuarios para mejorar el sitio (por ejemplo, Google Analytics).</li>
        <li><strong>Cookies de funcionalidad:</strong> recuerdan opciones elegidas por el usuario (idioma, modelo de interés).</li>
        <li><strong>Cookies de marketing:</strong> utilizadas para mostrar publicidad personalizada en plataformas externas (Meta, Google Ads), únicamente cuando el usuario lo autorice.</li>
      </ul>
      <p>
        El Titular puede deshabilitar el uso de cookies desde la configuración de su
        navegador. Sin embargo, deshabilitar ciertas cookies puede limitar la
        funcionalidad del sitio. El sitio respeta la señal &quot;Do Not Track&quot;
        cuando ésta es enviada por el navegador.
      </p>

      <h2>10. Cambios al Aviso de Privacidad</h2>
      <p>
        El presente Aviso de Privacidad podrá sufrir modificaciones, cambios o
        actualizaciones derivadas de nuevos requerimientos legales, de nuestras
        propias necesidades, de nuestras prácticas de privacidad o por otras causas.
        Cualquier modificación se pondrá a disposición del Titular en la presente
        página, con la fecha de la última actualización al inicio del documento.
      </p>

      <h2>11. Aceptación del Aviso de Privacidad</h2>
      <p>
        Al proporcionar sus datos personales al Responsable, ya sea de manera
        directa, indirecta o por medios electrónicos, el Titular manifiesta su
        conocimiento y aceptación del presente Aviso de Privacidad. Asimismo,
        autoriza expresamente el tratamiento de sus datos personales para las
        finalidades aquí descritas.
      </p>

      <h2>12. Contacto del Departamento de Datos Personales</h2>
      <p>
        Para cualquier duda, aclaración o solicitud relacionada con el presente Aviso
        de Privacidad o el tratamiento de datos personales, el Titular puede
        comunicarse al departamento responsable a través de:
      </p>
      <ul>
        <li><strong>Correo electrónico:</strong> <a href="mailto:contacto@quru.mx">contacto@quru.mx</a></li>
        <li><strong>Teléfono:</strong> <a href="tel:+525567911796">+52 55 6791 1796</a></li>
        <li><strong>Domicilio:</strong> Pachuca de Soto, Hidalgo, C.P. 42000, México.</li>
      </ul>
    </>
  );
}
